const NotFound = () => {
    return ( <div style={{'textAlign': 'center'}}>
        <h1>Page not found</h1>
        <h2>404</h2>
        <h3>Check the URL</h3>
    </div> );
}
 
export default NotFound;